import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FirestoreService } from "../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../api/firebase/references";
import { Authorization } from "../../data-model/AuthorizationModel";
import { AppDispatch } from "../store/store";

interface MedicalPaAuthorizationState {
  medicalPaAuthorization: Authorization | null;
  loading: boolean;
  error: string | null;
}

const initialState: MedicalPaAuthorizationState = {
  medicalPaAuthorization: null,
  loading: false,
  error: null,
};

const medicalPaAuthorizationSlice = createSlice({
  name: "medicalPaAuthorization",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },

    setMedicalPaAuthorization: (
      state,
      action: PayloadAction<Authorization | null>,
    ) => {
      state.medicalPaAuthorization = action.payload;
      state.loading = false;
      state.error = null;
    },

    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setMedicalPaAuthorization, setLoading, setError } =
  medicalPaAuthorizationSlice.actions;

export const getMedicalPaAuthorization =
  (orderId: string) => async (dispatch: AppDispatch) => {
    if (!orderId) {
      dispatch(setError("Order ID is required"));
      return;
    }

    try {
      dispatch(setLoading(true));

      const documentPath =
        FirestoreDocumentReference.medicalPaOrdersAuthorization(orderId);

      const authorization =
        await FirestoreService.getDocument<Authorization>(documentPath);

      dispatch(setMedicalPaAuthorization(authorization || null));
    } catch (error) {
      console.error("Error fetching medical PA authorization:", error);

      dispatch(
        setError(
          error instanceof Error ? error.message : "An unknown error occurred",
        ),
      );
    }
  };

export default medicalPaAuthorizationSlice.reducer;
